(function () {
    'use strict';

    angular
        .module('app')
        .controller('ReceiptController', ReceiptController);

    ReceiptController.$inject = ['$http', '$state', '$stateParams', '$scope', '$q', '$location', '$rootScope', '$cookies'];

    function ReceiptController($http, $state, $stateParams, $scope, $q, $location, $rootScope, $cookies) {
        $rootScope.dark_text_header = true;
        var vm = this;
        vm.$onInit = init;
        vm.close = close;
        vm.getItemQuantity = getItemQuantity;

        function init() {
            getCheckout();
        }

        function getCheckout() {
            return $http.post('/app/api/checkout/get/', { checkout_id: parseInt($stateParams.receipt_number), check_user: 1 })
                .then(function (response) {
                    /* if (!response.data.checkout_belongs_to_user) {
                        if (vm.checkoutType == 'gift_card') {
                            close();
                        }
                    } */
                    vm.checkoutItems = response.data.items;
                    vm.checkoutTotal = response.data.checkout_total;
                    vm.checkoutSubtotal = response.data.checkout_subtotal;
                    vm.checkoutCurrency = response.data.checkout_currency;
                    vm.checkoutId = response.data.checkout_id;
                    vm.userEmail = response.data.user_email;
                    vm.hasDiscount = response.data.has_discount;
                    vm.checkoutFee = response.data.checkout_fee;
                    vm.checkoutPaid = response.data.checkout_paid;
                    vm.checkoutType = response.data.checkout_type;
                    if (vm.checkoutType == 'band_booking') {
                        vm.band_booking_token = vm.checkoutItems[0].band_booking_token;
                        getBookingDetails().then(function () {
                            vm.vatDeduction = ((vm.details.band_booking_fee * (vm.details.band_booking_lowfi_percentage / 100)) + vm.checkoutFee) * 0.2;
                        });
                    }
                    if (vm.checkoutType == 'gift_card') {
                        vm.vatDeduction = vm.checkoutTotal - (vm.checkoutTotal * 0.8);
                    }
                });
        }

        function getItemQuantity(items, item, itemType) {
            if (itemType = 'Concert') {
                return item.num_of_tickets;
            }
            return items.filter(function (item) { return item.checkout_item_object_type == itemType; }).length;
        }


        function getBookingDetails() {
            return $http.get('api/booking/band/' + vm.band_booking_token)
                .then(function (response) {
                    vm.details = response.data;

                    vm.details.band_booking_date = moment(vm.details.band_booking_date).toDate();
                    vm.details.band_booking_time = moment(vm.details.band_booking_time, "hh:mm:ss").toDate();

                    vm.details.band_booking_low_fi_share = Math.round(vm.details.band_booking_fee * vm.details.band_booking_lowfi_percentage) / 100;
                    vm.details.band_booking_musician_share = Math.round(vm.details.band_booking_fee * vm.details.band_booking_band_percentage) / 100;
                });
        }

        function close() {
            return $state.go('frontpage');
        }

    }
})();
